module.exports = __webpack_public_path__ + "static/img/newCode.a5f838f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newCode.png
// module id = 54gq
// module chunks = 1